export interface OGImageInfoParams {
  autoFetchOgInfo: boolean
  imageUrl: string
  uploadImageBase64: string
}

export interface OGImageInfoResult {
  imageUrl: string
  uploadImageBase64: string
}

/**
 * 準備 OG 圖片資訊
 * @param params - OG 圖片相關參數
 * @returns 處理後的圖片資訊
 */
export const prepareOGImageInfo = (params: OGImageInfoParams): OGImageInfoResult => {
  const { autoFetchOgInfo, imageUrl, uploadImageBase64 } = params

  // autoFetchOgInfo 為 true 時上傳 OG 圖片連結
  if (autoFetchOgInfo) {
    return { imageUrl: imageUrl || '', uploadImageBase64: '' }
  }

  // autoFetchOgInfo 為 false 且 uploadImageBase64 有值時上傳本地圖片
  if (uploadImageBase64) {
    return { imageUrl: '', uploadImageBase64 }
  }

  // autoFetchOgInfo 為 false 且 uploadImageBase64 為空時上傳 OG 圖片連結
  return { imageUrl: imageUrl || '', uploadImageBase64: '' }
}

export interface ImageUpdateInfoParams {
  autoFetchOgInfo: boolean
  newOgImageUrl: string
  uploadImageBase64: string
}

export interface ImageUpdateInfoResult {
  newImageUrl: string
  newUploadImageBase64: string
  hasUpdateImage: boolean
}

/**
 * 獲取圖片更新資訊（僅編輯模式）
 * @param params - 圖片更新相關參數
 * @returns 圖片更新資訊
 */
export const getImageUpdateInfo = (params: ImageUpdateInfoParams): ImageUpdateInfoResult => {
  const { autoFetchOgInfo, newOgImageUrl, uploadImageBase64 } = params

  if (autoFetchOgInfo && newOgImageUrl) {
    return { newImageUrl: newOgImageUrl, newUploadImageBase64: '', hasUpdateImage: true }
  }

  if (!autoFetchOgInfo && uploadImageBase64) {
    return { newImageUrl: '', newUploadImageBase64: uploadImageBase64, hasUpdateImage: true }
  }

  if (!autoFetchOgInfo && !uploadImageBase64 && newOgImageUrl) {
    return { newImageUrl: newOgImageUrl, newUploadImageBase64: '', hasUpdateImage: true }
  }

  return { newImageUrl: '', newUploadImageBase64: '', hasUpdateImage: false }
}

/**
 * 添加 Query 參數到 URL
 * @param url - 原始 URL
 * @param params - 要添加的參數物件
 * @returns 添加參數後的 URL，若 URL 無效則返回空字串
 */
export const addQueryParamsToUrl = (url: string, params: Record<string, string>): string => {
  if (!url) {
    return ''
  }

  try {
    const urlObj = new URL(url)
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        urlObj.searchParams.set(key, value)
      }
    })
    return urlObj.toString()
  } catch (error) {
    console.error('Failed to construct URL:', error)
    return ''
  }
}
